export function getQueryParameter(source, param) {
    const search = source || window.location.search;
    return search?.includes("#") ? hashLookup(search, param) : searchLookup(search, param);
}

function searchLookup(search, param) {
    return search
        .replace("?", "")
        .split("&")
        .map(s => s.split("="))
        .find(arr => arr[0] === param);
}

function hashLookup(hash, param) {
    const queries = hash.slice(hash.indexOf("?") + 1);

    return queries
        ? queries
              .split("&")
              .map(s => s.split("="))
              .find(arr => arr[0] === param)
        : undefined;
}

export function getAccountIdParam(location, asNumber) {
    const accountRef = getQueryParameter(location.search, "account_reference");

    if (accountRef && accountRef.length === 2) {
        return asNumber ? parseInt(accountRef[1]) : accountRef[1];
    }

    return "default";
}

export function getClientReferenceParam(location) {
    const clientId = getQueryParameter(location.search, "client_reference");
    return clientId && clientId.length === 2 ? parseInt(clientId[1]) : 0;
}

export function isPrintMode(search) {
    return getQueryParameter(search ? search : window.location.search, "print") !== undefined;
}

export function isUsingLocalPrintServer() {
    return (
        isUsingPrintServerOverride() &&
        getQueryParameter(window.location.search, "overridePrintServer")?.[1].includes("localhost")
    );
}

export function isUsingPrintServerOverride() {
    const hasServerUrl = !!getQueryParameter(window.location.search, "overridePrintServer")?.[1];
    return window.location.search.includes("overridePrintServer") && hasServerUrl;
}

function getNuclearHost(location) {
    const nuclearHost = getQueryParameter(location.search, "nuclearHost");
    return nuclearHost ? "?nuclearHost=" + nuclearHost[1] : "";
}

export function getPdfPrinter(location) {
    if (isUsingPrintServerOverride()) return getLocalPrintServer(location);

    return location.origin.match(/(ppe|dev|localhost|docker|review)/g)
        ? "https://gutenberg.nucleuslab.io/pdf" + getNuclearHost(location)
        : "https://gutenberg.nucleusfinancial.io/pdf" + getNuclearHost(location);
}

export function getLocalPrintServer(location) {
    return getQueryParameter(location.search, "overridePrintServer")?.[1];
}

export function getDebugPrinter(location) {
    const printHost = getQueryParameter(location.search, "printHost");
    return printHost ? printHost[1] : "";
}

export function getUuid(location) {
    const uuid = getQueryParameter(location.search, "uuid");
    return uuid && uuid.length === 2 ? uuid[1] : uuid;
}

export function getPin(query) {
    const pin = getQueryParameter(query, "pin");

    return pin && pin.length && pin[0] === "pin" ? pin[1] : "";
}
